import { render } from "./TokenTxNep17.vue?vue&type=template&id=453d48d1"
import script from "./TokenTxNep17.vue?vue&type=script&lang=js"
export * from "./TokenTxNep17.vue?vue&type=script&lang=js"

import "./TokenTxNep17.vue?vue&type=style&index=0&id=453d48d1&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__